import { createSlice } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
    name: "ManagementPromo",
    initialState: {
        list: [],
        showDetail: false,
        loading: true,
        statusFilter: "",
        postPerPage: 5,
        fieldName: "",
        orderBy: "",
        search: "",
        currentPage: 0,
        totalData: 0,
        totalPage: 0,
        detailPromo: {},
        deleteModal: false
    },
    reducers: {
        setShowDetail: (state, action) => {
            state.showDetail = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        setPostPerPage: (state, action) => {
            state.postPerPage = action.payload;
        },
        setFieldName: (state, action) => {
            state.fieldName = action.payload;
        },
        setOrderBy: (state, action) => {
            state.orderBy = action.payload;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalData: (state, action) => {
            state.totalData = action.payload;
        },
        setTotalPage: (state, action) => {
            state.totalPage = action.payload;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        setDetailPromo: (state, action) => {
            state.detailPromo = action.payload;
        },
        setDeleteModal: (state, action) => {
            state.deleteModal = action.payload;
        }
    }
});

export const {
    setShowDetail,
    setStatusFilter,
    setPostPerPage,
    setFieldName,
    setOrderBy,
    setSearch,
    setCurrentPage,
    setTotalData,
    setTotalPage,
    setList,
    setLoading,
    setDetailPromo,
    setDeleteModal
} = reducerSlice.actions;

export default reducerSlice;